<template>
    <app-field :error="error" :classes="classes" :append="append">
        <app-label v-if="label != ''" :label="label" :required="required" :description="description"></app-label>
        
        <div slot="input">
           <vue-medialibrary-field 
                v-model="content" 
                :helper="helper" 
                :types="types" 
                :filetypes="filetypes" 
            />
        </div>
    </app-field>
</template>

<script>
    /* API */
    import Api from '@/api/index.js';
    import Vue from 'vue';

    /* Components */
    import Field from '@/components/fields/Field';
    import Label from '@/components/fields/Label';
    
    export default {
        name: 'app-field-file',
        components: {
            'app-field': Field,
            'app-label': Label,
        },
        props: {
            label: {
                type: String,
                default: ''
            },
            helper: {
                type: String,
                required: false,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            description: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                default: ''
            },
            classes: {
                type: Object,
                default: () => ({})
            },
            append: {
                type: String,
                default: ''
            },
            types: {
                type: Object,
                required: false,
                default: () => ({
                    images: true,
                    files: true
                })
            },
            filetypes: {
                type: Array,
                required: false,
                default: () => ([])
            },
        },

        data: () => ({
            content: null,
        }),

        mounted() {
            this.content = this.value ? this.value : this.content;
        },

        computed: {
            options() {
                let classes = {};
                if(typeof this.classes.input != 'undefined' && Object.keys(this.classes.input).length > 0) {
                    classes = {
                        ...this.classes.input
                    };
                }
                if(this.error != '') {
                    classes['error'] = true;
                }
                return classes;
            }
        },

        methods: {
            update() {
                this.$emit('input', this.content);
            },
        },

        watch: {
            content() {
                this.update();
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../sass/modules/inputs.scss';
</style>


// WEBPACK FOOTER //
// src/components/fields/inputs/File.vue